import Button from 'components/Form/Button';
import Check from 'components/Form/Check';
import BasicTable from 'components/Form/Table';
import TableWrapper from 'components/TableWrapper';
import ContainerAuthenticated from 'containers/Authenticated';
import { CoreContext } from 'context/CoreContext';
import moment from 'moment';
import { useContext, useEffect, useMemo, useState } from 'react';
import { Read } from 'services/financing-desk-controls';
import { exposeStrapiError, formatarValor, marcadorDiferente } from 'utils';
import { formatadores, normalizeName } from 'utils/validators';

export default function ControlDeskInstallation() {
  const { user, filterExpression, setModal } = useContext(CoreContext);
  const [registers, setRegisters] = useState([]);

  const columns = useMemo(() => {
    const defaultColumns = [
      {
        title: 'Id',
        sortable: true,
        ref: 'id',
        renderCell: ({ row }) => {
          // Condição: Se o campo 'curadoria_analise' for 'Analisado'
          const isAnalisado = row?.curadoria_analise === 'Analisado';
          const id = row?.proposta_financeira?.id || row?.proposta;
          if (isAnalisado) {
            return marcadorDiferente(id, '!');
          }
          return id;
        },
      },
      // Lógica do ciclo de vida comentada
      {
        title: 'Data Contato',
        sortable: true,
        ref: 'dataContato',
        align: 'center',
        renderCell: ({ row }) => formatadores.TIMESTAMP_TO_BR(row?.dataContato),
      },
      { title: 'Proposta', ref: 'cod_proposta_externa' },
      ...(user?.administrador ||
      (user?.distribuidores && user.distribuidores.length >= 1)
        ? [
            {
              title: 'Distribuidor',
              sortable: true,
              ref: 'distributor',
            },
          ]
        : []),
      { title: 'Integrador', sortable: true, ref: 'integrator' },
      { title: 'Cliente', sortable: true, ref: 'cliente' },
      { title: 'Cidade', ref: 'cidade' },
      { title: 'UF', ref: 'uf' },
      { title: 'Concessionária', ref: 'concessionaria' },
      { title: 'KWP', ref: 'kwp' },
      {
        title: 'Instalação',
        ref: '',
        align: 'center',
        renderCell: ({ row }) => (
          <Check
            checked={row?.instalacao === 'Sim' ? true : false}
            label={''}
            align="center"
          />
        ),
      },
      {
        title: 'Protocolo',
        ref: '',
        renderCell: ({ row }) => (
          <Check
            checked={row?.protocolo === 'Sim' ? true : false}
            label={''}
            align="center"
          />
        ),
      },
      ...(user?.administrador
        ? [
            {
              title: 'Observações',
              renderCell: ({ row }) => (
                <Button
                  onClick={() => {
                    setModal({
                      type: 'observacao',
                      dados: row,
                      origem: 'Instalação e Vistoria',
                      reload: () => init(),
                    });
                  }}
                  color="botao"
                  nospace
                  mbutton
                  small
                >
                  Adicionar
                </Button>
              ),
            },
          ]
        : []),
    ];
    return defaultColumns.filter((f) => f);
  }, [user, setModal]);

  const rows = useMemo(() => {
    return registers
      ?.filter((item) => !(item.instalacao && item?.protocolo))
      .map((item) => ({
        proposta: item?.proposta_financeira?.id,
        id: item?.id,
        original: item,
        data: item?.proposta_financeira?.createdAt,
        formatedDate: formatadores.TIMESTAMP_TO_BR(
          item?.proposta_financeira?.createdAt
        ),
        cliente: item?.proposta_financeira?.informacoes_cliente?.nome_completo,
        //usado no filtro:
        distributor: normalizeName(
          item?.proposta_financeira?.distribuidor?.trade_name
        ),
        integrator: normalizeName(
          item?.proposta_financeira?.integrador?.nome_fantasia
        ),
        uf: item?.proposta_financeira?.endereco_instalacao?.uf,
        status: normalizeName(item?.proposta_financeira?.status),
        //fim do filtro.
        cidade: normalizeName(
          item?.proposta_financeira?.endereco_instalacao?.cidade
        ),
        concessionaria: normalizeName(
          item?.proposta_financeira?.informacoes_projeto?.concessionaria
        ),
        kwp: formatarValor(
          item?.proposta_financeira?.informacoes_projeto?.potencia_kWp
        ),
        cod_proposta_externa: normalizeName(
          item?.proposta_financeira?.cod_proposta_externa
        ),
        address: item?.proposta_financeira?.endereco_instalacao?.rua,
        instalacao: item?.instalacao ? 'Sim' : 'Não',
        protocolo: item?.protocolo_acesso ? 'Sim' : 'Não',
        dataContato:
          item?.data_entrada_protocolo || item?.data_enviar_protocolo,
        formatedDateContact: formatadores.TIMESTAMP_TO_BR(
          item?.data_entrada_protocolo || item?.data_enviar_protocolo
        ),
        dataContatoInst:
          item?.data_entrada_instalacao || item?.data_enviar_instalacao,
        formatedDateContactInst: formatadores.TIMESTAMP_TO_BR(
          item?.data_entrada_instalacao || item?.data_enviar_instalacao
        ),
        curadoria_analise: item?.curadoria_analise, // Assumindo que este campo está no backend
        curadoria_analise_bot: item?.curadoria_analise_bot,
        // cnpj_integrador: item?.proposta_financeira?.integrador?.cnpj,
        // cnpj_integrador_clean:
        //   item?.proposta_financeira?.integrador?.cnpj.replace(/\D/g, ''),
        // cpf_cnpj:
        //   item?.proposta_financeira?.informacoes_cliente?.cpf ||
        //   item?.proposta_financeira?.informacoes_cliente?.cnpj,
        // cpf_cnpj_clean: item?.proposta_financeira?.informacoes_cliente?.cpf
        //   ? item?.proposta_financeira?.informacoes_cliente?.cpf.replace(
        //       /\D/g,
        //       ''
        //     )
        //   : item?.proposta_financeira?.informacoes_cliente?.cnpj.replace(
        //       /\D/g,
        //       ''
        //     ),
        cpf_cnpj: item?.cpf_cliente || '-',
        cpf_cnpj_clean:
          item?.cpf_cliente ?? item?.cpf_cliente.replace(/\D/g, ''),
      }));
  }, [registers]);
  const init = async () => {
    // filtra para mostrar os status e caso tenha alguma proposta vazia nao traz resultado.
    const result = await Read(
      '?filters[$or][0][status][$eq]=Entrega e Parecer de acesso' +
        '&filters[$or][1][status][$eq]=Instalação e Protocolo de conexão' +
        '&filters[$or][2][status][$eq]=Expedição' +
        '&filters[proposta_financeira][id][$notNull]=true'
    );
    if (result && !exposeStrapiError(result)) {
      const nresult = result.results
        ?.map((m) => {
          // const proposta_financeira = normalizeStrapiRegister(m?.proposta_financeira)
          // const protocolo_acesso_midia = normalizeStrapiRegister(m?.protocolo_acesso_midia)
          // const bank = proposta_financeira?.propostas_banco?.find(f => f.aceito)
          return {
            ...m,
            // proposta_financeira,
            // protocolo_acesso_midia,
            // bank: {
            //   ...bank,
            //   banco: normalizeStrapiRegister(bank?.banco)
            // }
          };
        })
        ?.sort((a, b) => {
          // Pega a data de contato para a proposta 'a'
          const dateA = moment(a.data_entrada_conexao || a.data_enviar_conexao);
          // Pega a data de contato para a proposta 'b'
          const dateB = moment(b.data_entrada_conexao || b.data_enviar_conexao);
          // Retorna a diferença
          // Se dateA for mais antiga, o resultado é negativo e 'a' é colocado antes de 'b'.
          return dateA - dateB;
        });
      setRegisters(nresult);
    }
  };

  useEffect(() => init(), []);

  return (
    <ContainerAuthenticated>
      <TableWrapper title={'Instalação e Protocolo de Vistoria'} search>
        <BasicTable
          columns={columns}
          rows={rows?.filter(filterExpression)}
          pagination
        />
      </TableWrapper>
    </ContainerAuthenticated>
  );
}
